import React from "react";
import { translation } from 'easit--localization';

export interface IOfflineProps {
    isLoading: boolean;
    onCheck?: () => void;
}

export const OfflinePage: React.StatelessComponent<IOfflineProps> = (props) => {

    return <div className="offline-alert">
        <div className="alert alert-warning">
            {translation().offline_InfoText}
            <button className="btn btn-primary btn-sm ml-2" onClick={() => { !props.isLoading && props.onCheck(); }}>{translation().offline_TryReconnect}
                {
                    props.isLoading &&
                    <span className="fas fa-spinner fa-spin ml-2"></span>
                }
            </button>
        </div>
    </div>
}
